var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"package-type-switch"},_vm._l((_vm.available_package_type_options),function(package_type_option){return _c('button',{key:package_type_option.value,class:`package-type-switch--button ${
      package_type_option.value === _vm.package_type ? 'active' : ''
    }`,on:{"click":() => _vm.select_package_type(package_type_option.value)}},[_vm._v(" "+_vm._s(package_type_option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }